module.exports = __webpack_public_path__ + "static/img/流程.1223f25c.png";